/** Home hero situations (Redesign v3 board copy, verbatim). `{duration}` is filled from services.duration_min. */
export type HomeSituation = { slug: string; chip: string; line: string; hook: string };

export const HOME_SITUATIONS: HomeSituation[] = [
  {
    slug: "tifli-yadribni",
    chip: "طفلي بيضرب",
    line: "الضرب بهذا العمر توتّر ما له لغة تطلّعه — مش كره، ومش قلّة احترام.",
    hook: "إذا المقال ما كفّى: {duration} دقيقة مع د. سارة عن هذا الموقف بالذات.",
  },
  {
    slug: "nawm-al-tifl",
    chip: "ما بينام لحاله",
    line: "النوم بيحتاج أمان قبل أي تقنية. والتراجع المفاجئ غالباً إشارة، مش عادة.",
    hook: "إذا المقال ما كفّى: {duration} دقيقة مع د. سارة عن نوم طفلك بالذات.",
  },
  {
    slug: "al-shashat-wa-dimagh-al-tifl",
    chip: "الشاشات",
    line: "الشاشات علاقة منديرها، مش معركة منربحها أو منخسرها.",
    hook: "إذا المقال ما كفّى: {duration} دقيقة مع د. سارة عن الشاشات ببيتك بالذات.",
  },
  {
    slug: "ibni-yadrib-akhah",
    chip: "شجار الإخوة",
    line: "أول خطوة مع اللي انضرب، مش مع اللي ضرب. والباقي بيجي بعدها.",
    hook: "إذا المقال ما كفّى: {duration} دقيقة مع د. سارة عن الإخوة ببيتك بالذات.",
  },
  {
    slug: "al-tifl-al-anid",
    chip: "عنيد وما بيسمع الكلام",
    line: "«العنيد» مش صفة بالطفل — وصف للحظة ما فهمنا فيها شو عم يصير.",
    hook: "إذا المقال ما كفّى: {duration} دقيقة مع د. سارة عن هذا الموقف بالذات.",
  },
];

/** The three posts in «3 مقالات لحالتك», in order. */
export const HOME_CARD_SLUGS = ["nawm-al-tifl", "tifli-yadribni", "al-shashat-wa-dimagh-al-tifl"];

export const HOME_POST_SLUGS = Array.from(
  new Set([...HOME_SITUATIONS.map((s) => s.slug), ...HOME_CARD_SLUGS]),
);
